import { Box, Icon, PopoverMenu, Text } from '@factorialco/deprecated-design-system'

import LabeledInput from 'modules/core/components/LabeledInput'
import i18n from 'modules/core/lib/i18n'

import RolesAndLevelsEntitySelector from 'modules/project_management/components/tables/JobsAndRatesDataCollection/RolesAndLevelsSelector'
import { SelectedLevelItem } from 'modules/project_management/components/tables/JobsAndRatesDataCollection/types'

interface RolesAndLevelsEntityPopoverProps {
  existingResourceJobLevelIds?: string[]
  isJobCatalogTreeEnabled: boolean
  isSingleSelector?: boolean
  onUpdate: (values: { levels?: SelectedLevelItem[] }) => void
  selectedLevelIds: string[]
  selectorText: string
  hideLabel?: boolean
}

const RolesAndLevelsEntityPopover = ({
  existingResourceJobLevelIds = [],
  isJobCatalogTreeEnabled,
  isSingleSelector = false,
  onUpdate,
  selectedLevelIds = [],
  selectorText,
  hideLabel = false,
}: RolesAndLevelsEntityPopoverProps) => {
  const selectorTrigger = (
    <Box
      gap="s8"
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      border={{
        all: {
          width: 's2',
          style: 'solid',
          color: 'grey400',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
      padding="s8"
      paddingX="s16"
      cursor="pointer"
    >
      <Text.Normal ellipsis>{selectorText}</Text.Normal>
      <Icon.Small icon="caret-down" color="grey600" />
    </Box>
  )

  return (
    <PopoverMenu type="dialog">
      <PopoverMenu.Trigger>
        {hideLabel ? (
          selectorTrigger
        ) : (
          <LabeledInput
            isLegend
            label={i18n.t('project_management.jobs_and_rates.sidepanels.form.select_jobs.label')}
          >
            {selectorTrigger}
          </LabeledInput>
        )}
      </PopoverMenu.Trigger>
      <PopoverMenu.Content side="bottom" align="center" width="s400" hideWhenDetached>
        <Box gap="s16" alignItems="center">
          <RolesAndLevelsEntitySelector
            selectedLevelIds={selectedLevelIds}
            setValues={(partial) => {
              if (partial.levels) {
                onUpdate({ levels: partial.levels })
              }
            }}
            existingResourceJobLevelIds={existingResourceJobLevelIds}
            isJobCatalogTreeEnabled={isJobCatalogTreeEnabled}
            isSingleSelector={isSingleSelector}
          />
        </Box>
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}

export default RolesAndLevelsEntityPopover
